export default __webpack_public_path__ + "static/media/Antique-Cobble-I-Charcoal-Tumbled.0d192250.jpg";